/*
 *  顶踩数字展示
 *      1.<1000显示数字
 *      2.>=1000 <10000  显示x.xk.小数点后保存一位,0也算
 *      3.>=10000 显示x.xw 规则跟上面一样
 */
function likesText(likes = 0) {
  switch (true) {
    case likes < 1000:
      return likes;
    case likes < 10000:
      return `${(likes / 1000).toFixed(1)}k`;
    default:
      return `${(likes / 10000).toFixed(1)}w`;
  }
}

/* 视频播放时间 */
function videoTimeText(num) {
  const minutes = parseInt(`${(num / 60)}`, 10);
  const second = parseInt(`${(num % 60)}`, 10);
  const fix = str => str.padStart(2, '0');
  return `${fix(minutes)}:${fix(second)}`;
}

export {likesText, videoTimeText}


// WEBPACK FOOTER //
// ./src/tools/lib/numberToText.js